export const environment = {
  production: false,
  local:'https://reclutamiento26-api.tumsa.mx/api/',
  localstatic:'https://reclutamiento26-api.tumsa.mx/',
  socketlocal:'http://172.17.1.7:3001'
};